export default {
    template: require("./reassigning-booking.component.html")
}

